import React from 'react'
import { RI_CLIC_ITI, TAG_MULTIPATH_CTA } from '../../analytics/analytics.tagids.constants'
import { MODAL_IDS } from '../../../store/ui/ui.constants'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import { withOnlyGE } from '../../Device'
import RectangleActionButton, { COLOR_BLUE, SIZE_MEDIUM } from '../../genericComponents/buttons/RectangleActionButton'
import { withFrenchSite } from '../../i18n/i18nSite'
import useModal from '../../ui/useModal'
import useEventCallback from '../../utils/useEventCallback'
import ItineraryButtonContainer from '../ItineraryButtonContainer'
import { CLICKED_BUTTON } from '../../analytics/analytics.constants'
import TagActionButton from '../../genericComponents/TagActionButton'

const ShareItineraryRouteButton = ({ route, className }) => {
  const { displayModal } = useModal(MODAL_IDS.SHARE_ITINERARY_POPIN)

  const onButtonClick = useEventCallback(displayModal)

  return (
    <ItineraryButtonContainer className={className}>
      <TagActionButton type={RI_CLIC_ITI} key={route.routeId}>
        <RectangleActionButton
          color={COLOR_BLUE}
          onClick={onButtonClick}
          deferClick
          tagData={{
            tagInfo: { provider: route.provider, tag: PUB_TAG.PUB_MULTIPATH_GOTO_MOBILE },
            type: TAG_MULTIPATH_CTA
          }}
          label={'Envoyer sur mon mobile'}
          dataset={{ [CLICKED_BUTTON]: 'Envoyer sur mon mobile' }}
          size={SIZE_MEDIUM}
        />
      </TagActionButton>
    </ItineraryButtonContainer>
  )
}

export default withFrenchSite(withOnlyGE(ShareItineraryRouteButton))
